// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__222QC","additionalInfo":"AgreementModal_additionalInfo__3nWnJ"};